export default "__VITE_ASSET__DE9dDphW__"